import { useEffect } from "react";
import { useCompany } from "@/context/CompanyContext";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

/**
 * The "Company" field of a form.
 *
 * One licence is one company, so an organisation with a single company never sees this field: it is filled in
 * silently. An organisation that still has several companies sees the usual dropdown.
 */
export function CompanyField({ value, onChange, testId, label = "Company", required = true, placeholder = "Select", triggerClassName = "mt-1.5", className }) {
  const { companies, singleCompany } = useCompany() || {};

  useEffect(() => {
    if (singleCompany && value !== singleCompany.id) onChange(singleCompany.id);
  }, [singleCompany, value]); // eslint-disable-line react-hooks/exhaustive-deps

  if (singleCompany) return null;
  return (
    <div className={className}>
      <Label>{label}</Label>
      <Select required={required} value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className={triggerClassName}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>{(companies || []).map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}

/** Wrap a company filter or picker that only makes sense when the organisation has several companies. */
export function HideWhenSingleCompany({ children }) {
  const { singleCompany } = useCompany() || {};
  return singleCompany ? null : children;
}
